// -----------------------------
// Extractors: metadata and keywords
// -----------------------------

import { ContextEngine } from '@/types';
import { safeGetMeta } from '../utils/dom';
import { pathSegments } from '../utils/url';

export function extractMetadata(doc: Document): ContextEngine.Metadata {
  return {
    title: doc?.title?.trim() ?? null,
    description:
      safeGetMeta(doc, 'description') || safeGetMeta(doc, 'og:description'),
    keywords: safeGetMeta(doc, 'keywords'),
    ogTitle: safeGetMeta(doc, 'og:title'),
    ogImage: safeGetMeta(doc, 'og:image'),
  };
}

export function extractKeywords(
  url: string,
  doc: Document,
  baseOrigin?: string
): string[] {
  const kws = new Set<string>();
  try {
    for (const seg of pathSegments(url, baseOrigin)) {
      if (seg && seg.length > 2) kws.add(seg.replace(/[-_]/g, ' '));
    }
    const metaKw = safeGetMeta(doc, 'keywords');
    if (metaKw) metaKw.split(',').forEach(k => kws.add(k.trim()));
    if (doc.title) kws.add(doc.title.trim());
    const h1 = doc.querySelector('h1');
    if (h1?.textContent) kws.add(h1.textContent.trim());
    Array.from(doc.querySelectorAll('h2'))
      .slice(0, 3)
      .forEach(h => {
        if (h?.textContent) kws.add(h.textContent.trim());
      });
  } catch {
    // ignore
  }
  return Array.from(kws).slice(0, 10);
}

export function extractDomElementText({
  doc,
  querySelector,
}: {
  doc?: Document;
  querySelector: string;
}): string | null {
  try {
    const el = doc?.querySelector(querySelector);
    if (el?.textContent) return el.textContent.trim();
    return null;
  } catch (error) {
    console.error(
      `Error extracting text from DOM element: '${querySelector}'`,
      error
    );
    return null;
  }
}
